import styled, { css } from 'styled-components';
import { applyStyleModifiers } from 'styled-components-modifiers';
import { flex, media } from 'components/styles';

// Import helpers
import { TAGS_TYPES } from 'helpers/tags';

const LIST_ITEM_MODIFIER = {
	[TAGS_TYPES.TEXT]: ({ theme }) => css`
		&:not(:last-of-type)::after {
			content: '';
			display: block;
			width: 0.1rem;
			height: 0.9em;
			background-color: ${theme.white};
			margin: 0 0.7em;
		}
	`,
	[TAGS_TYPES.ICON]: ({ isNextText }) => css`
		&:not(:last-of-type) {
			margin-right: ${isNextText ? 0.7 : 0.35}em;
		}

		img {
			width: 1.3em;
			height: 1.3em;
		}
	`
};

export const MetadataLists = styled.div`
	font-size: 1.2rem;
	color: ${({ theme }) => theme.white};
	font-weight: ${({ theme }) => theme.font.light};
	${flex({ ai: 'flex-start', fd: 'column' })}

	${media.min.min(css`
		font-size: 1.75rem;
	`)}
`;

export const ListItem = styled.li`
	position: relative;
	${flex}
	${applyStyleModifiers(LIST_ITEM_MODIFIER)}
`;

export const List = styled.ul`
	${flex({ jc: 'flex-start', ai: 'flex-start' })}
	list-style: none;
	margin-bottom: 0.6em;

	&:last-of-type {
		margin-bottom: 1.7em;
	}
`;
